const collectionOverview = new Swiper(".collection-overview-container", {
  // Optional parameters
  mousewheel: {
    forceToAxis: true,
  },
  freeMode: {
    enabled: true,
  },
  navigation: {
    nextEl: ".collection-overview-button-next",
    prevEl: ".collection-overview-button-prev",
  },
  breakpoints: {
    // when window width is >= 320px
    990: {
      slidesPerView: 3.8,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    750: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    // when window width is >= 640px
    0: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
  },
})
